// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-navbars-breadcrumb-index[data-v-503da8ce] {\n  height: 50px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: var(--prev-bg-topBar);\n  border-bottom: 1px solid var(--prev-border-color-lighter);\n}", ""]);
// Exports
module.exports = exports;
